/**
 * PaperFormFooter — closing courtesy line + source-of-design citation.
 * Renders a thin top border, an italic muted closing line (e.g. "Thank you
 * for your prompt response..."), and an even-fainter form-ID strip below
 * the form card.
 */

import React from "react";
import { Box, Typography } from "@mui/material";

export default function PaperFormFooter({
  closingText,    // e.g. "Thank you for your prompt response to this request for information."
  citation,       // e.g. "Form F-1.6 · Source-of-design: Chesakl Enterprises Form F1.6.0 (D-033 §3.1)"
}) {
  return (
    <>
      {closingText && (
        <Box
          sx={{
            mt: 5,
            pt: 3,
            borderTop: "1px solid",
            borderColor: "divider",
            textAlign: "center",
          }}
        >
          <Typography
            variant="caption"
            sx={{ color: "text.disabled", fontStyle: "italic" }}
          >
            {closingText}
          </Typography>
        </Box>
      )}
      {citation && (
        <Box sx={{ mt: 3, textAlign: "center" }}>
          <Typography variant="caption" sx={{ color: "text.disabled" }}>
            {citation && /^per\b/i.test(String(citation).trim()) ? citation : `per ${citation}`}
          </Typography>
        </Box>
      )}
    </>
  );
}
